import { ICommandResult } from "../../../Common/domain/src/api/commandResult";

export interface CustomerShortNameAndCode {
  code: string,
  shortName: string
}

export const START_ASSOCIATION_FLOW = "START_ASSOCIATION_FLOW";
export const START_ASSOCIATION_FLOW_FAIL = "START_ASSOCIATION_FLOW_FAIL";
export const START_CUSTOMERSSHORTNAMEANDCODE_FLOW = "START_CUSTOMERSSHORTNAMEANDCODE_FLOW";
export const START_CUSTOMERSSHORTNAMEANDCODE_FLOW_FAIL = "START_CUSTOMERSSHORTNAMEANDCODE_FLOW_FAIL";
export interface GetCustomersShortNameAndCodeState {
  result: CustomerShortNameAndCode[];
}

export interface GetCustomersShortNameAndCodeType {
  type: typeof START_CUSTOMERSSHORTNAMEANDCODE_FLOW | typeof START_CUSTOMERSSHORTNAMEANDCODE_FLOW_FAIL;
  payload: CustomerShortNameAndCode[];
}

export type CustomersShortNameAndCodeType = GetCustomersShortNameAndCodeType;

export interface GetAssociationFlowState {
  result: ICommandResult;
}

export interface GetAssociationFlowType {
  type: typeof START_ASSOCIATION_FLOW | typeof START_ASSOCIATION_FLOW_FAIL;
  payload: ICommandResult;
}

export type AssociationFlowType = GetAssociationFlowType;
